import Vue from 'vue';
import Axios from 'axios';
import stringify from 'qs-stringify';
import router from '@/router';
import { TokenService, ProfileService } from './local-storage';
import toast from '../libs/toastify';

function destroyLocalToken() {
  TokenService.remove();
  ProfileService.remove();
  router.push('/login');
}

// create axios instance
const instanceAxios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// update token every request
instanceAxios.interceptors.request.use(
  (config) => {
    const token = TokenService.get();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

instanceAxios.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401) {
    // toast.warning('Your session has expired, Please login again');
    destroyLocalToken();
  } else if (error.response?.status === 403) {
    toast.warning(`Forbidden! ${error.response.data.message}`);
  } else if (error.response?.status === 429) {
    toast.warning('Error Too many request');
  } else if (error.response?.status >= 500) {
    toast.warning(`${error.response.status} API Server Error`);
  } else if (error.response?.status === 400) {
    console.log('Error 400 Bad request');
  }
  throw error;
});

const endpoints = {
  login(data) {
    return instanceAxios.post('/login', data);
  },

  getStocksData(params) {
    return instanceAxios.get('/stocks', { params });
  },

  getCancelToken() {
    return Axios.CancelToken.source();
  },
  isCancel(err) {
    return Axios.isCancel(err);
  },
};

// global this.$api
Vue.prototype.$api = endpoints;

// also support for single import
export default endpoints;
